import Icon from 'rv-components-onze/src/Icon'
import {
  contactLinks,
  generalTerms,
  socialMediaLinks,
  usefulLinks,
} from './constants'
import Accordion from './components/Accordion'

import enhancer from './hooks'

const Footer = () => {
  return (
    <div className="footer-landing">
      <div className="container footer-landing__content">
        <div className="footer-landing__main-info">
          <div className="footer-landing-main-info__onze">
            <div className="address">
              <Icon iconId="onze-logo" />
              <p className="footer-landing-main-info__description no-hover">
                Rua Olimpíadas, 242 - 4º andar
              </p>
              <p className="footer-landing-main-info__description no-hover">
                Itaim Bibi, São Paulo
              </p>

              <div className="social-links">
                {socialMediaLinks.map((item, index) => (
                  <a
                    className="social-links__item"
                    target="_blank"
                    title={`${item.icon} da Onze`}
                    href={item.link}
                    key={`${item.icon}-${index}`}>
                    <Icon iconId={`icon-${item.icon}`} />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="footer-landing-main-info__onze footer-landing-main-info__onze--desktop">
            <h4 className="footer-landing-main-info__title">Links úteis</h4>
            {usefulLinks.map((item, idx) => (
              <a
                key={idx}
                className="footer-landing-main-info__description"
                href={item.link}
                target="_blank">
                {item.text}
              </a>
            ))}

            <h4 className="footer-landing-main-info__title margin-top">
              Termos legais
            </h4>
            {generalTerms.map((item, index) => (
              <a
                className="footer-landing-main-info__description"
                href={item.link}
                title={item.name}
                target="_blank"
                key={`${item.name}-${index}`}>
                {item.text}
              </a>
            ))}
          </div>
          <div className="footer-landing-main-info__onze footer-landing-main-info__onze--desktop">
            <h4 className="footer-landing-main-info__title">Contatos</h4>
            {contactLinks.map((item, index) => (
              <a
                key={index}
                className="footer-landing-main-info__description"
                href={item.link}>
                {item.text}
              </a>
            ))}
            <h4 className="footer-landing-main-info__title margin-top">
              Privacidade e proteção de dados
            </h4>
            <p className="footer-landing-main-info__description no-hover">
              Ronaldo Orbite
            </p>
            <p className="footer-landing-main-info__description no-hover">
              dpo@onze.com.br
            </p>
          </div>
          {/* )} */}
        </div>
      </div>

      <div className="footer-landing__mobile-accordions">
        <Accordion title="Links úteis" phrasesList={usefulLinks} />
        <Accordion title="Contatos" phrasesList={contactLinks} />
        <Accordion title="Termos legais" phrasesList={generalTerms} />
      </div>

      <div className="footer-landing__certifications rights">
        <div className="container">
          <p className={`footer-landing__certifications-description`}>
            A Onze Corretora de Seguros LTDA., inscrita sob o CNPJ
            29.178.278/0001-35, é uma instituição autorizada a funcionar pela
            SUSEP - Superintendência de Seguros Privados. Toda comunicação
            através da rede mundial de computadores está sujeita a interrupções
            ou atrasos, podendo prejudicar a troca de informações atualizadas
            momentaneamente. A Onze exime-se de responsabilidade por danos
            sofridos por seus clientes ou por força de falha de serviços
            disponibilizados por terceiros.
          </p>
        </div>
      </div>
    </div>
  )
}

export default enhancer(Footer)
